import React, { useEffect, useState } from "react";
import Modal from "../../../modal/modal";
import Button from "../../../button/button";
import Input from "../../../../DesignSystem/Atoms/Input/Input";
import "./CertificateTrackingLinkModal.scss";

const formatDate = (dateValue) => {
    if (!dateValue) return "";

    const date = new Date(dateValue);

    if (Number.isNaN(date.getTime())) return dateValue;

    return new Intl.DateTimeFormat("es-MX", {
        dateStyle: "medium",
        timeStyle: "short",
        timeZone: "America/Tijuana",
    }).format(date);
};

const CertificateTrackingLinkModal = ({
    isOpen,
    mode,
    trackingLink,
    trackingLinks,
    currentEmployee,
    onClose,
    onSave,
    showAlert,
    saving = false,
}) => {
    const [folio, setFolio] = useState("");
    const [trackingUrl, setTrackingUrl] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!isOpen) return;

        setFolio(trackingLink?.folio || "");
        setTrackingUrl(trackingLink?.tracking_url || "");
        setErrors({});
    }, [isOpen, trackingLink]);

    const validateForm = () => {
        const newErrors = {};
        const normalizedFolio = folio.trim();
        const normalizedUrl = trackingUrl.trim();
        const duplicatedFolio = trackingLinks.some((currentLink) =>
            currentLink.folio.trim().toLocaleLowerCase("es") === normalizedFolio.toLocaleLowerCase("es") &&
            currentLink.id !== trackingLink?.id
        );

        if (!normalizedFolio) {
            newErrors.folio = "El folio es obligatorio";
        } else if (duplicatedFolio) {
            newErrors.folio = "Ya existe un registro con este folio";
        }

        if (!normalizedUrl) {
            newErrors.trackingUrl = "El link de seguimiento es obligatorio";
        } else if (!/^https?:\/\/\S+$/i.test(normalizedUrl)) {
            newErrors.trackingUrl = "El link debe iniciar con http:// o https://";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            showAlert("danger", "Verifique los campos marcados");
            return false;
        }

        return true;
    };

    const handleSave = () => {
        if (saving) return;
        if (!validateForm()) return;

        onSave({
            folio: folio.trim(),
            tracking_url: trackingUrl.trim(),
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} overlayClick={false}>
            <div className="certificate-tracking-link-modal">
                <div className="certificate-tracking-link-modal__header">
                    <h1 className="title-1">
                        {mode === "edit" ? "Editar link de seguimiento" : "Agregar link de seguimiento"}
                    </h1>
                    <p>
                        El folio debe ser único y el enlace debe dirigir a una página externa segura.
                    </p>
                </div>

                <div className="certificate-tracking-link-modal__form">
                    <Input
                        value={folio}
                        onChange={(event) => {
                            setFolio(event.target.value);
                            setErrors((currentErrors) => ({ ...currentErrors, folio: "" }));
                        }}
                        placeholder="Folio"
                        error={errors.folio}
                    />
                    <Input
                        type="url"
                        value={trackingUrl}
                        onChange={(event) => {
                            setTrackingUrl(event.target.value);
                            setErrors((currentErrors) => ({ ...currentErrors, trackingUrl: "" }));
                        }}
                        placeholder="Link de seguimiento"
                        error={errors.trackingUrl}
                    />

                    <div className="certificate-tracking-link-modal__automatic-data">
                        <h2>Datos automáticos</h2>
                        <div>
                            <Input
                                value={trackingLink?.created_by?.name || currentEmployee.name}
                                placeholder="Registrado por"
                                disabled
                                readOnly
                            />
                            <Input
                                value={
                                    trackingLink?.created_at
                                        ? formatDate(trackingLink.created_at)
                                        : "Se asignará al guardar"
                                }
                                placeholder="Fecha de registro"
                                disabled
                                readOnly
                            />
                        </div>
                        <p>
                            Estos datos no son editables. Al conectar el backend se asignarán desde la sesión del usuario y la fecha del servidor.
                        </p>
                    </div>
                </div>

                <div className="confirm-buttons-section">
                    <Button
                        text="Cancelar"
                        backgroundColor="red"
                        onClick={onClose}
                        disabled={saving}
                    />
                    <Button
                        text={
                            saving
                                ? "Guardando..."
                                : mode === "edit"
                                    ? "Guardar cambios"
                                    : "Agregar link"
                        }
                        onClick={handleSave}
                        disabled={saving}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default CertificateTrackingLinkModal;
